import { useLocation } from "react-router-dom";
import { cloneElement, useCallback, useEffect, useState } from "react";
import SectionBanner from "../app/sections/common/banner/banner";
import { setBannerData } from "../globals/layout-config";

function InnerPageLayout(props) {
    const currentpath = useLocation().pathname;
    const [bannerData, setBannerDataState] = useState(setBannerData(currentpath));

    const applyBannerOverrides = useCallback((overrides = {}) => {
        setBannerDataState((prev) => ({
            ...prev,
            ...overrides
        }));
    }, []);

    useEffect(() => {
        setBannerDataState(setBannerData(currentpath));
    }, [currentpath]);

    const contentWithProps = props.content
        ? cloneElement(props.content, { setBanner: applyBannerOverrides })
        : null;

    return (
        <>
            {/* Inner Banner */}
            <SectionBanner data={bannerData} />

            {
                contentWithProps
            }
        </>
    )
}
export default InnerPageLayout;